import { HttpParams } from "@angular/common/http";
import { filterQueryStringKey, getWindowRef, isWidget } from "@hiptraveler/common";

export function buildBrandInfoParams(): HttpParams {

  const wb = new URLSearchParams(
    getWindowRef()[filterQueryStringKey] ?? ''
  ).get('wb');

  let params = new HttpParams().set(
    'param',
    isWidget() ? 'widget' : 'full'
  );

  if (wb) {
    params = params.set('wbId', wb);
  }

  return params;
}
